module.exports = __webpack_public_path__ + "img/rent-tab-inactive.66b7ad15.svg";